//#region types
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ShareRegisterRejectFormContainer from "./rejectFormContainer";
//#endregion

function useShareRegisterRejectDialog(onRejectSuccess?: (value?: any) => void, onError?: (value?: any) => void) {
  const getRejectDialog = (id: number): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Deny),
      titleIcon: IconDefinitionConstants.WStop,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Send),
          successMessage: TranslationKeys.ShareRegister.ShareRegisterRejectSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <ShareRegisterRejectFormContainer id={id} />,
      maxWidth: "sm",
      onSubmit: onRejectSuccess,
      onError: onError,
    };
  };

  return getRejectDialog;
}

export default useShareRegisterRejectDialog;
